import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/home';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/70'
          : 'bg-background-50/40 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg md:text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-wide">
                黑料热点
              </span>
              <span className="font-label text-[10px] md:text-xs text-foreground-500 tracking-[0.3em] mt-0.5">
                WINDPOST
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="font-label text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#flash"
              className="hidden md:inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-radar-line" />
              看今日风向
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300/70 text-foreground-800 cursor-pointer"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50">
          <nav className="px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="py-3 font-label text-sm text-foreground-700 border-b border-background-200/60 last:border-b-0 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#flash"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-label cursor-pointer"
            >
              <i className="ri-radar-line" />
              看今日风向
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}